import React from 'react'
import { DollarSign } from 'react-feather'

const PackageCard = ({packageOrder}) => {
  return (
      <div className="col-md-4">
          <div className="card rounded-4 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center gap-2  mb-3 ">
              <div className='text-green'>  <DollarSign />  </div> 
                <h5 className="text-smoke font16 font700"> معلومات طرود التوصيل</h5>
              </div>
              <ul className="d-flex flex-column gap-2   mt-2">
                <div>
                  <h6 className="text-gray">تفاصبل الحزمة</h6>
                  <h6 className='text-smoke'> {packageOrder?.description} </h6>
                </div>
                  <li className="d-flex align-items-center gap-1 ">
               الوزن <span className='text-smoke'>{packageOrder?.weight}</span>
                </li>
                <li className="d-flex align-items-center gap-1 ">
               الطول <span className='text-smoke'>{packageOrder?.dimensions?.length}</span>
                </li>
                  <li className="d-flex align-items-center gap-1 ">
               العرض <span className='text-smoke'>{packageOrder?.dimensions?.width}</span>
                </li>
                  <li className="d-flex align-items-center gap-1 ">
                الارتفاع<span className='text-smoke'> {packageOrder?.dimensions?.height} </span>
                </li>
                   <li className="d-flex align-items-center gap-1 ">
                الحجم<span className='text-smoke'> {packageOrder?.volume} </span>
                </li>
                   <li className="d-flex align-items-center gap-1 ">
                قابل للكسر<span className='text-smoke'> {packageOrder?.is_fragile ? "نعم":"لا"} </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
  )
}

export default PackageCard